import {
  AppNotification,
  NotificationType,
} from '../../../../components/notification/Notification'
import { useDeleteDebounce } from '../../../../utils/useDeleteDebounce'
import { IChooseItems } from '../../../../components/mainContent/TableAllDishes'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useArchiveMultipleCategoryMutation } from '../../../../core/api/CategoryApi'

interface UseDeleteCategoryResponse {
  deletePopup: boolean
  onDeletePopupHandler: () => void
  onDeleteHandler: () => void
  closeDeletePopup: () => void
}

export const useDeleteCategory = (
  chooseItems: IChooseItems | null,
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>,
): UseDeleteCategoryResponse => {
  const [deletePopup, setDeletePopup] = useState(false)
  const [archiveMultipleCategory] = useArchiveMultipleCategoryMutation()
  const { t } = useTranslation()

  const deleteCategoryHandler = async () => {
    if (!!chooseItems) {
      archiveMultipleCategory({
        categories: Object.keys(
          Object.fromEntries(
            Object.entries(chooseItems).filter((e) => e.includes(true)),
          ),
        ).map((item) => Number(item)),
      })
        .unwrap()
        .then(() => {
          AppNotification({
            msg: t('Выбранные категории успешно удалены!'),
            type: NotificationType.success,
          })
          setChooseItems(null)
        })
    }
  }

  const [onDeleteHandler] = useDeleteDebounce({
    fn: deleteCategoryHandler,
    extraText: t(
      'Выбранные вами категории будут удалены на сервере и на всех станциях!',
    ),
  })

  const closeDeletePopup = () => setDeletePopup(false)
  const openDeletePopup = () => setDeletePopup(true)

  return {
    deletePopup,
    onDeletePopupHandler:
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
        ? openDeletePopup
        : onDeleteHandler,
    onDeleteHandler,
    closeDeletePopup,
  }
}
